import { BoxDetailTemplateProps } from '@/box/interface'
import { getFormatMessage } from '@/utils/utils'
import { Tabs } from 'antd'
import React, { useEffect } from 'react'
import { BoxDetailAlarm } from './alarm'
import { BoxDetailMacros } from './macros'
import { BoxDetailPlc } from './plc'
import { BoxDetailTransfer } from './transfer'
import { BoxDetailVariable } from './variable'

export const BoxDetailTemplate: React.FC<BoxDetailTemplateProps> = (
  props: BoxDetailTemplateProps
) => {
  const formatMessage = getFormatMessage()

  // 控件销毁
  useEffect(() => {
    // 默认选中第一个tab
    props.onTabChange?.('item.variable')
    return () => props?.onDestory?.()
  }, [])

  return (
    <div>
      <Tabs activeKey={props.activeKey} onChange={props.onTabChange}>
        <Tabs.TabPane
          tab={formatMessage({ id: 'app.box.detail.template.variable' })}
          key='item.variable'
        >
          <BoxDetailVariable
            contactTemplate={props.template}
            detailItem={props.detailItem}
            values={props.variableValues}
            onVariablePushStatusChange={props.onVariablePushStatusChange}
            onVariableSearch={props.onVariableSearch}
            onValueSet={props.onValueSet}
            pagination={props.variablePagination}
          />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={formatMessage({ id: 'app.box.detail.template.alarm' })}
          key='item.alarm'
        >
          <BoxDetailAlarm
            contactTemplate={props.template}
            detailItem={props.detailItem}
            onAlarmPushStatusChange={props.onAlarmPushStatusChange}
          />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={formatMessage({ id: 'app.box.detail.template.macros' })}
          key='item.macros'
        >
          <BoxDetailMacros
            contactTemplate={props.template}
            detailItem={props.detailItem}
          />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={formatMessage({ id: 'app.box.detail.template.transfer' })}
          key='item.transfer'
        >
          <BoxDetailTransfer
            contactTemplate={props.template}
            detailItem={props.detailItem}
          />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={formatMessage({ id: 'app.box.detail.template.plc' })}
          key='item.plc'
        >
          <BoxDetailPlc
            contactTemplate={props.template}
            detailItem={props.detailItem}
          />
        </Tabs.TabPane>
      </Tabs>
    </div>
  )
}
